import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading, user, authInProgress } = useAuth();
  const location = useLocation();

  // Show loading while checking auth OR while auth is in progress
  if (loading || authInProgress) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
          <p className="text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Use window.location for consistent behavior across all browsers
    window.location.href = '/login';
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
          <p className="text-muted-foreground">Redirecionando...</p>
        </div>
      </div>
    );
  }

  // Check admin/teacher access for admin routes
  if (adminOnly) {
    const isAdmin = user?.is_admin || user?.role === 'admin';
    const isTeacher = user?.role === 'teacher';
    
    if (!isAdmin && !isTeacher) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
